<script lang="ts">
const __DsBlock = {
	type: 'input',
	category: 'input',
	hidden: true,
}
</script>
<script setup lang="ts">
import type { InputBlockProps } from '#layers/blocks/types/input-block';
import type { GlobalSingleRelationFieldId } from '#layers/data-model/public';
import { computed } from 'vue';
import { canAssignPolicy, connectRolePolicies, disconnectRolePolicies } from '#layers/access/public';
import { defineBlock } from '#layers/block-engine/public';
import RelatedItemListCard from '#layers/blocks/components/Relation/RelatedItemListCard.vue';
import { useRelationFormField } from '#layers/forms/public';
import { useAssignmentBlock } from './use-assignment-block';

interface MonospacePolicy {
	id: string;
	name: string;
}

export interface InputPolicyAssignmentBlockProps extends InputBlockProps {
	fieldId?: GlobalSingleRelationFieldId;
}

const { disabled, disabledNotice, fieldId } = defineProps<InputPolicyAssignmentBlockProps>();

;

const { referencedItemKey: roleKey } = useRelationFormField(() => ({ disabled, disabledNotice, fieldId }));

const { cardProps } = useAssignmentBlock<MonospacePolicy>({
	collectionApiName: 'RawMonospacePolicy',
	displayCollectionName: 'MonospacePolicy',
	ownerId: computed(() => roleKey.value?.id),
	entitlement: canAssignPolicy(),
	relation: { field: 'roles', ownerKey: 'roleId' },
	junction: { collectionApiName: 'MonospaceRolePolicy', ownerKey: 'roleId', targetKey: 'policyId' },
	attach: ({ fetch, ids, ownerId }) => connectRolePolicies({ fetch, policyIds: ids, roleId: ownerId }),
	detach: ({ fetch, ids, ownerId }) => disconnectRolePolicies({ fetch, policyIds: ids, roleId: ownerId }),
	errorMessages: {
		attach: 'pages.settings.access.errors.attach_policies_failed',
		detach: 'pages.settings.access.errors.detach_policies_failed',
	},
});
</script>

<template>
	<RelatedItemListCard
		v-if="cardProps"
		v-bind="cardProps"
		:disabled
		:disabled-notice
	/>
</template>
